var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsePreviousIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 17,
    viewBox: "0 0 31 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67738 11.2222C6.05004 11.7344 5.26529 12.0147 4.45539 12.0159L4.45639 12.0149C3.7913 12.0149 3.13986 11.8262 2.57774 11.4707C2.01562 11.1152 1.56588 10.6076 1.28076 10.0067C0.995652 9.40581 0.886866 8.73637 0.967042 8.07613C1.04722 7.41589 1.31307 6.79195 1.73371 6.27677C2.15435 5.7616 2.71252 5.37634 3.34338 5.16573C3.97425 4.95513 4.65191 4.92784 5.29767 5.08702C5.94343 5.2462 6.53078 5.58532 6.99149 6.065C7.4522 6.54467 7.76737 7.14521 7.90039 7.79686H19.4294L18.6414 7.00786L19.6354 6.01386L22.1214 8.49986L19.6354 10.9859L18.6414 9.99186L19.4294 9.20387H7.89939C7.73631 9.99717 7.30473 10.71 6.67738 11.2222ZM6.20996 9.67156C6.4417 9.32474 6.56539 8.91699 6.56539 8.49986C6.56486 7.94069 6.34249 7.40456 5.94709 7.00916C5.5517 6.61376 5.01557 6.39139 4.45639 6.39086C4.03927 6.39086 3.63152 6.51455 3.28469 6.74629C2.93787 6.97803 2.66755 7.30741 2.50793 7.69278C2.3483 8.07815 2.30654 8.5022 2.38791 8.91131C2.46929 9.32042 2.67015 9.6962 2.9651 9.99115C3.26005 10.2861 3.63584 10.487 4.04495 10.5683C4.45405 10.6497 4.8781 10.608 5.26347 10.4483C5.64884 10.2887 5.97822 10.0184 6.20996 9.67156Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5H29C29.8284 0.5 30.5 1.17157 30.5 2V15C30.5 15.8284 29.8284 16.5 29 16.5H13C12.1716 16.5 11.5 15.8284 11.5 15V2C11.5 1.17157 12.1716 0.5 13 0.5Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsePreviousIcon);
export default __webpack_public_path__ + "static/media/use-previous-icon.ba6681f0062b0b4a0fbae2667a1dddc5.svg";
export { ForwardRef as ReactComponent };